import { post } from "../http/platformServer";
import mainServerClient from "../http/mainServerClient";

/**
 * 1. 0代表可使用次数为0
 * 2. 部分功能荣誉版或荣誉版v1可以使用，所以不存在值即代表可以使用该功能
 * 3. 高级版不用请求接口获取次数，因为高级版是所有功能都可以使用 */
export interface PremiumFeatureTrial {
    ORDER_SPLITTING?: number;
    OPERATION_LOG?: number;
    PRE_SHIPPING?: number;
    LOGISTICS_AUDIT?: number;
}

interface GetPremiumFeatureTrialRemainingTimesResult {
    shopId: number;
    premiumFeatureTrial: PremiumFeatureTrial;
}

/** 获取高级版功能剩余体验次数 */

export function getNodePremiumFeatureTrialRemainingTimes(
    shopIds: number[],
): Promise<GetPremiumFeatureTrialRemainingTimesResult[]> {
    return post(shopIds[0], "/premium_feature_trial/get_remaining_times", { shopIds });
}

export function getMainPremiumFeatureTrialRemainingTimes(
    shopIds: number[],
): Promise<GetPremiumFeatureTrialRemainingTimesResult[]> {
    return mainServerClient.post("/premium_feature_trial/get_remaining_times", { shopIds });
}
